import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './PaginationControls.module.scss';
import PaginationButtons from '../../PaginationButtons/PaginationButtons';

interface PaginationControlsProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (p: number) => void;
}

export default function PaginationControls({ page, pageSize, total, onPageChange }: PaginationControlsProps) {
  const { t } = useTranslation();
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  const handlePaginationClick = (direction: 'previous' | 'next') => {
    if (direction === 'previous') {
      const newPage = page <= 1 ? totalPages : page - 1;
      onPageChange(newPage);
    } else if (direction === 'next') {
      const newPage = page >= totalPages ? 1 : page + 1;
      onPageChange(newPage);
    }
  };

  return (
    <div className={classNames(styles.root, 'w-full flex items-center')}>
      <div className="ml-auto flex items-center gap-x-12">
        <span className="typo-text-12--bold">
          {t('general.page')} {page} {t('general.of')} {totalPages}
        </span>
        <PaginationButtons
          onClick={handlePaginationClick}
          disabledPrevious={totalPages === 1}
          disabledNext={totalPages === 1}
        />
      </div>
    </div>
  );
}
